import { render, staticRenderFns } from "./dragTable.vue?vue&type=template&id=425b464b&scoped=true&"
import script from "./dragTable.vue?vue&type=script&lang=js&"
export * from "./dragTable.vue?vue&type=script&lang=js&"
import style0 from "./dragTable.vue?vue&type=style&index=0&id=425b464b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425b464b",
  null
  
)

export default component.exports